import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { deleteTalentPool } from 'mojo-talent-pools';

export interface RemoveTalentPoolModalComponentData {
  talentPoolId: number;
  page: number;
}

@Component({
  selector: 'mojo-remove-talent-pool-modal',
  templateUrl: './remove-talent-pool-modal.html',
  styleUrls: ['./remove-talent-pool-modal.scss'],
})
export class RemoveTalentPoolModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RemoveTalentPoolModalComponentData,
    private store: Store,
    private dialogRef: MatDialogRef<RemoveTalentPoolModalComponent>,
  ) {}

  removeTalentPool() {
    this.store.dispatch(
      deleteTalentPool({
        talentPoolId: this.data.talentPoolId,
        page: this.data.page,
      }),
    );

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
